import React from 'react'
import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { CourseStepButton } from 'modules/course/components/course-state-button'
import type { CourseQuizDataResultInterface } from 'modules/course/types/course-quiz-interface'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseQuizLayout } from '../course-quiz-layout'
import { CourseQuizResetButton } from '../course-quiz-reset-button'
import { QuestionItem } from '../question-item'
import { AnswersList } from './answers-list'

interface CourseQuizResultsScreenProps {
  className?: string
  courseQuizData: CourseQuizDataResultInterface | undefined
}

export const CourseQuizResultsScreen = ({
  className,
  courseQuizData,
}: React.PropsWithChildren<CourseQuizResultsScreenProps>): ReactNode => {
  const { t } = useTranslation()

  const numberOfRightAnswers =
    courseQuizData?.q.reduce(
      (res, question) => (question.a.every(answer => answer.c === answer.s) ? res + 1 : res),
      0,
    ) || 0

  return (
    <CourseQuizLayout
      className={`${className} ${addPublicCustomClassNamePrefix('course-quiz__container--results')}`}
      questionCounter={t(
        numberOfRightAnswers > 1
          ? 'course.quiz.questions_counter_other'
          : 'course.quiz.questions_counter_one',
        {
          number: `${numberOfRightAnswers}/${courseQuizData?.q.length}`,
        },
      )}
      questions={courseQuizData?.q.map(({ t: question, a: answers }, index) => (
        <QuestionItem key={index} question={question}>
          <AnswersList className={'mt-6'} answers={answers} />
        </QuestionItem>
      ))}
      buttons={
        <>
          <CourseStepButton />
          <CourseQuizResetButton />
        </>
      }
    />
  )
}
